"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationSchemaProperties = exports.OrganizationSchema = exports.CustomFieldTemplateSchema = exports.InvoiceCustomFieldTemplateSchema = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
exports.InvoiceCustomFieldTemplateSchema = zod_1.z.object({
    title: zod_1.z.string(),
    value: zod_1.z.string(),
});
const UserInvoiceCustomizationSchema = zod_1.z.object({
    memo: zod_1.z.string().optional(),
    footer: zod_1.z.string().optional(),
    customFields: zod_1.z.array(exports.InvoiceCustomFieldTemplateSchema).optional(),
});
const ZapierTrigger = zod_1.z
    .object({
    targetUrl: zod_1.z.string(),
})
    .nullable()
    .optional();
const ZapierTriggerName = zod_1.z.enum([
    "appointment_created",
    "appointment_rescheduled",
    "appointment_canceled",
    "appointment_completed",
    "appointment_outcome_updated",
]);
const ZapierTriggers = zod_1.z.record(ZapierTriggerName.or(zod_1.z.string()), ZapierTrigger.array());
const SessionBillingOutcomeHistoryItemSchema = zod_1.z.object({
    createdAt: zod_1.z.date(),
    memberId: zod_1.z.string(),
    outcomeIds: zod_1.z.array(zod_1.z.string()),
});
const BillableReviewerSchema = zod_1.z.object({
    accountId: zod_1.z.string(),
    addedAt: zod_1.z.date(),
    addedBy: zod_1.z.string(),
});
const SessionBillingCycle = zod_1.z.enum([
    "monthly",
    "weekly",
    "bi-weekly",
    "twice-per-month",
]);
const SessionBillingCountingRule = zod_1.z.enum(["all-sessions", "complete-only"]);
const SessionBillingSettingsSchema = zod_1.z.object({
    currency: zod_1.z.string(),
    cycle: SessionBillingCycle,
    countingRule: SessionBillingCountingRule,
    startDate: zod_1.z.date(),
    endDay: zod_1.z.number().optional(),
    timeZone: zod_1.z.string(),
    acceptedOutcomesHistory: zod_1.z
        .array(SessionBillingOutcomeHistoryItemSchema)
        .optional(),
    billableReviewers: zod_1.z.array(BillableReviewerSchema).optional(),
});
exports.CustomFieldTemplateSchema = zod_1.z.object({
    field: zod_1.z.string(),
    icon: zod_1.z.string(),
    required: zod_1.z.boolean(),
    type: zod_1.z.string(),
    options: zod_1.z
        .object({
        items: zod_1.z.array(zod_1.z.string()),
        select: zod_1.z.enum(["single", "multi"]),
    })
        .optional(),
});
const OrganizationAccountStatus = zod_1.z.enum(["active", "paused"]);
exports.OrganizationSchema = base_schema_1.BaseSchema.extend({
    accountStatus: OrganizationAccountStatus.optional(),
    ownerId: zod_1.z.string().optional(),
    email: zod_1.z.string().email(),
    companyName: zod_1.z.string().optional(),
    brandId: zod_1.z.string().optional(),
    timeZone: zod_1.z.string().optional(),
    companyLogo: zod_1.z
        .object({
        url: zod_1.z.string().optional(),
    })
        .optional()
        .nullable(),
    slug: zod_1.z.string(),
    memberAccountIds: zod_1.z.array(zod_1.z.string()).optional(),
    domains: zod_1.z
        .object({
        domainName: zod_1.z.string().optional(),
        useCustomDomain: zod_1.z.boolean().optional(),
    })
        .optional(),
    stripe: zod_1.z
        .object({
        stripe_user_id: zod_1.z.string().optional(),
        stripe_customer_id: zod_1.z.string().optional(),
    })
        .optional(),
    zapierTriggers: ZapierTriggers.optional().nullable(),
    customFields: zod_1.z.array(exports.CustomFieldTemplateSchema).optional(),
    sessionBillingSettings: SessionBillingSettingsSchema.optional(),
    invoiceCustomization: UserInvoiceCustomizationSchema.optional().nullable(),
    // Deprecated Fields
    firstName: zod_1.z.string().optional(),
    lastName: zod_1.z.string().optional(),
    isCoach: zod_1.z.boolean().optional(),
    coachOnboardedAt: zod_1.z.date().optional(),
    lastUsedCurrency: zod_1.z.string().optional(),
    lastUsedTaxTypeId: zod_1.z.string().optional(),
});
exports.OrganizationSchemaProperties = {
    collectionName: "users",
    deleteMode: schema_properties_interface_1.DeleteMode.Hard,
};
//# sourceMappingURL=organization-schema.js.map